export enum APPMODE {
  Web = 'Web',
  Template = 'Template',
  Customer = 'Customer',
  Admin = 'Admin',
  Kiosk = 'Kiosk',
}
